import React from 'react';
import DynamicFormViewer from '../../Components/FormData/DynamicFormViewer';
import {
  getAllShareYourThoughts,
  deleteShareYourThoughts,
  updateShareYourThoughtsById,
} from '../../Redux/Store/API/FormsData/ShareYourThoughts';

export default function ShareThoughtsFormData() {
  const headers = [
    { key: 'firstname', label: 'First Name' },
    { key: 'lastname', label: 'Last Name' },
    { key: 'mobileNo', label: 'Mobile No' },
    { key: 'reference', label: 'Reference' },
    { key: 'comment', label: 'Thoughts / Comments' },
    { key: 'sourcePage', label: 'Source Page', render: (v) => v || '—' },
  ];

  return (
    <DynamicFormViewer
      title="Shared Thoughts Submissions"
      headers={headers}
      fetchAction={getAllShareYourThoughts}
      deleteAction={deleteShareYourThoughts}
      updateAction={updateShareYourThoughtsById}
      stateSliceName="shareYourThoughts"
      dataKey="getallshareYourThoughts"
    />
  );
}